import type React from 'react';

export const HeaderPageSkeleton: React.FC = () => {
  return (
    <div className="animate-pulse py-8 px-6">
      {/* ヘッダー部分のスケルトン */}
      <div className="h-5 bg-neutral-200 rounded w-30 mb-2" />
      <div className="h-9 bg-neutral-200 rounded w-1/4 mb-6" />
    </div>
  );
};
